import React from 'react'
import { useIntl } from 'react-intl';
import Hero from '../../components/Hero';
import TelecomLinkBoxRow from '../../components/TelecomLinkBoxRow';

export type NOM_221_SCFI_2017Props = {};

const NOM_221_SCFI_2017: React.FC<NOM_221_SCFI_2017Props> = () => {
  const intl = useIntl();
  return (
    <div className="w-full flex flex-col">
      <Hero
        bgImage={'/img/telecom-header-planet.png'} 
        heading={intl.formatMessage({
          id: "telecommunications",
          defaultMessage: "Telecommunications"
        })}
        subHeading='NOM-221-SCFI-2017'
      />
      <TelecomLinkBoxRow />
      <div className="content !px-4 md:!px-2 lg:!px-0 !py-16">
        <div className="flex w-full flex-col items-start justify-center">
          <div className="flex flex-col w-full pt-0 md:pt-6 pb-10 md:pb-0 gap-10 pr-10 max-w-[950px]">
            <div className="">
              <h2 className='text-xl text-secondary font-bold mb-2'>
                NOM-221-SCFI-2017
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "mobile_devices",
                    defaultMessage: "Specifications of mobile terminal equipment that can make use of the radio spectrum or be connected to telecommunications networks. Part 1. Equipment manufacturing identity code (IMEI) and frequency modulated (FM) sound broadcast receiver functionality."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'scope',
                    defaultMessage: "Scope:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "mobile_devices_covered",
                    defaultMessage: "The products covered by this Official Mexican Standard are all those Mobile Terminal Equipment that can make use of the radio spectrum or be connected to telecommunications networks."
                  })
                }
              </p>
              <p>
                {
                  intl.formatMessage({
                    id: "mobile_devices_covered_2",
                    defaultMessage: "Mobile Terminal Equipment that is using international roaming within the national territory is exempt."
                  })
                }
              </p>
            </div>
            <div>
              <h2 className='text-xl text-secondary font-bold uppercase mb-2'>
                {
                  intl.formatMessage({
                    id: 'products_terminal_example',
                    defaultMessage: "Examples of equipment subject to compliance with the NOM:"
                  })
                }
              </h2>
              <p>
                {
                  intl.formatMessage({
                    id: "imei_devices",
                    defaultMessage: "Any device that can operate on the network with an IMEI code"
                  })
                }
              </p>
              <p>
                {
                  intl.formatMessage({
                    id: "imei_devices_2",
                    defaultMessage: "Cell phones, tablets, routers or modems with access to the cellular network"
                  })
                }
              </p>
            </div>
          </div>
          <div className="w-full mt-12 flex justify-center">
            <img className="max-w-md w-full" src="/img/mobile-devices.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NOM_221_SCFI_2017;